"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e) {
  var t = {};

  function i(n) {
    if (t[n]) return t[n].exports;
    var s = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(s.exports, s, s.exports, i), s.l = !0, s.exports;
  }

  i.m = e, i.c = t, i.d = function (e, t, n) {
    i.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, i.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, i.t = function (e, t) {
    if (1 & t && (e = i(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (i.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var s in e) {
      i.d(n, s, function (t) {
        return e[t];
      }.bind(null, s));
    }
    return n;
  }, i.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return i.d(t, "a", t), t;
  }, i.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, i.p = "", i(i.s = 2);
}([function (e, t, i) {
  var n;
  /*! picturefill - v3.0.2 - 2016-02-12
   * https://scottjehl.github.io/picturefill/
   * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
   */

  /*! Gecko-Picture - v1.0
   * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
   * Firefox's early picture implementation (prior to FF41) is static and does
   * not react to viewport changes. This tiny module fixes this.
   */

  !function (e) {
    var t,
        i,
        n,
        s,
        r,
        o,
        a,
        c = navigator.userAgent;
    e.HTMLPictureElement && /ecko/.test(c) && c.match(/rv\:(\d+)/) && RegExp.$1 < 45 && addEventListener("resize", (i = document.createElement("source"), n = function n(e) {
      var t,
          n,
          s = e.parentNode;
      "PICTURE" === s.nodeName.toUpperCase() ? (t = i.cloneNode(), s.insertBefore(t, s.firstElementChild), setTimeout(function () {
        s.removeChild(t);
      })) : (!e._pfLastSize || e.offsetWidth > e._pfLastSize) && (e._pfLastSize = e.offsetWidth, n = e.sizes, e.sizes += ",100vw", setTimeout(function () {
        e.sizes = n;
      }));
    }, s = function s() {
      var e,
          t = document.querySelectorAll("picture > img, img[srcset][sizes]");

      for (e = 0; e < t.length; e++) {
        n(t[e]);
      }
    }, r = function r() {
      clearTimeout(t), t = setTimeout(s, 99);
    }, o = e.matchMedia && matchMedia("(orientation: landscape)"), a = function a() {
      r(), o && o.addListener && o.addListener(r);
    }, i.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", /^[c|i]|d$/.test(document.readyState || "") ? a() : document.addEventListener("DOMContentLoaded", a), r));
  }(window),
  /*! Picturefill - v3.0.2
   * http://scottjehl.github.io/picturefill
   * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
   *  License: MIT
   */
  function (s, r, o) {
    "use strict";

    var a, c, l;
    r.createElement("picture");

    var d = {},
        u = !1,
        f = function f() {},
        h = r.createElement("img"),
        p = h.getAttribute,
        m = h.setAttribute,
        g = h.removeAttribute,
        v = r.documentElement,
        y = {},
        _ = {
      algorithm: ""
    },
        A = navigator.userAgent,
        b = /rident/.test(A) || /ecko/.test(A) && A.match(/rv\:(\d+)/) && RegExp.$1 > 35,
        $ = "currentSrc",
        w = /\s+\+?\d+(e\d+)?w/,
        S = /(\([^)]+\))?\s*(.+)/,
        k = s.picturefillCFG,
        C = "font-size:100%!important;",
        x = !0,
        T = {},
        E = {},
        j = s.devicePixelRatio,
        z = {
      px: 1,
      in: 96
    },
        L = r.createElement("a"),
        M = !1,
        P = /^[ \t\n\r\u000c]+/,
        R = /^[, \t\n\r\u000c]+/,
        D = /^[^ \t\n\r\u000c]+/,
        O = /[,]+$/,
        F = /^\d+$/,
        B = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
        H = function H(e, t, i, n) {
      e.addEventListener ? e.addEventListener(t, i, n || !1) : e.attachEvent && e.attachEvent("on" + t, i);
    },
        W = function W(e) {
      var t = {};
      return function (i) {
        return i in t || (t[i] = e(i)), t[i];
      };
    };

    function I(e) {
      return " " === e || "\t" === e || "\n" === e || "\f" === e || "\r" === e;
    }

    var U,
        G,
        Q,
        N,
        V,
        q,
        Y,
        X,
        J,
        K,
        Z,
        _ee,
        te,
        _ie,
        ne,
        se,
        re = (U = /^([\d\.]+)(em|vw|px)$/, G = W(function (e) {
      return "return " + function () {
        for (var e = arguments, t = 0, i = e[0]; ++t in e;) {
          i = i.replace(e[t], e[++t]);
        }

        return i;
      }((e || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "") + ";";
    }), function (e, t) {
      var i;
      if (!(e in T)) if (T[e] = !1, t && (i = e.match(U))) T[e] = i[1] * z[i[2]];else try {
        T[e] = new Function("e", G(e))(z);
      } catch (e) {}
      return T[e];
    }),
        oe = function oe(e, t) {
      return e.w ? (e.cWidth = d.calcListLength(t || "100vw"), e.res = e.w / e.cWidth) : e.res = e.d, e;
    },
        ae = function ae(e) {
      if (u) {
        var t,
            i,
            n,
            s = e || {};

        if (s.elements && 1 === s.elements.nodeType && ("IMG" === s.elements.nodeName.toUpperCase() ? s.elements = [s.elements] : (s.context = s.elements, s.elements = null)), n = (t = s.elements || d.qsa(s.context || r, s.reevaluate || s.reselect ? d.sel : d.selShort)).length) {
          for (d.setupRun(s), M = !0, i = 0; i < n; i++) {
            d.fillImg(t[i], s);
          }

          d.teardownRun(s);
        }
      }
    };

    function ce(e, t) {
      return e.res - t.res;
    }

    function le(e, t) {
      var i, n, s;
      if (e && t) for (s = d.parseSet(t), e = d.makeUrl(e), i = 0; i < s.length; i++) {
        if (e === d.makeUrl(s[i].url)) {
          n = s[i];
          break;
        }
      }
      return n;
    }

    s.console && console.warn, $ in h || ($ = "src"), y["image/jpeg"] = !0, y["image/gif"] = !0, y["image/png"] = !0, y["image/svg+xml"] = r.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"), d.ns = ("pf" + new Date().getTime()).substr(0, 9), d.supSrcset = "srcset" in h, d.supSizes = "sizes" in h, d.supPicture = !!s.HTMLPictureElement, d.supSrcset && d.supPicture && !d.supSizes && (Q = r.createElement("img"), h.srcset = "data:,a", Q.src = "data:,a", d.supSrcset = h.complete === Q.complete, d.supPicture = d.supSrcset && d.supPicture), d.supSrcset && !d.supSizes ? (N = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", V = r.createElement("img"), q = function q() {
      2 === V.width && (d.supSizes = !0), c = d.supSrcset && !d.supSizes, u = !0, setTimeout(ae);
    }, V.onload = q, V.onerror = q, V.setAttribute("sizes", "9px"), V.srcset = N + " 1w,data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw== 9w", V.src = N) : u = !0, d.selShort = "picture>img,img[srcset]", d.sel = d.selShort, d.cfg = _, d.DPR = j || 1, d.u = z, d.types = y, d.setSize = f, d.makeUrl = W(function (e) {
      return L.href = e, L.href;
    }), d.qsa = function (e, t) {
      return "querySelector" in e ? e.querySelectorAll(t) : [];
    }, d.matchesMedia = function () {
      return s.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? d.matchesMedia = function (e) {
        return !e || matchMedia(e).matches;
      } : d.matchesMedia = d.mMQ, d.matchesMedia.apply(this, arguments);
    }, d.mMQ = function (e) {
      return !e || re(e);
    }, d.calcLength = function (e) {
      var t = re(e, !0) || !1;
      return t < 0 && (t = !1), t;
    }, d.supportsType = function (e) {
      return !e || y[e];
    }, d.parseSize = W(function (e) {
      var t = (e || "").match(S);
      return {
        media: t && t[1],
        length: t && t[2]
      };
    }), d.parseSet = function (e) {
      return e.cands || (e.cands = function (e, t) {
        function i(t) {
          var i,
              n = t.exec(e.substring(l));
          if (n) return i = n[0], l += i.length, i;
        }

        var n,
            s,
            r,
            o,
            a,
            c = e.length,
            l = 0,
            d = [];

        function u() {
          var e,
              i,
              r,
              o,
              a,
              c,
              l,
              u,
              f,
              h = !1,
              p = {};

          for (o = 0; o < s.length; o++) {
            c = (a = s[o])[a.length - 1], l = a.substring(0, a.length - 1), u = parseInt(l, 10), f = parseFloat(l), F.test(l) && "w" === c ? ((e || i) && (h = !0), 0 === u ? h = !0 : e = u) : B.test(l) && "x" === c ? ((e || i || r) && (h = !0), f < 0 ? h = !0 : i = f) : F.test(l) && "h" === c ? ((r || i) && (h = !0), 0 === u ? h = !0 : r = u) : h = !0;
          }

          h || (p.url = n, e && (p.w = e), i && (p.d = i), r && (p.h = r), r || i || e || (p.d = 1), 1 === p.d && (t.has1x = !0), p.set = t, d.push(p));
        }

        function f() {
          for (i(P), r = "", o = "in descriptor";;) {
            if (a = e.charAt(l), "in descriptor" === o) {
              if (I(a)) r && (s.push(r), r = "", o = "after descriptor");else {
                if ("," === a) return l += 1, r && s.push(r), void u();
                if ("(" === a) r += a, o = "in parens";else {
                  if ("" === a) return r && s.push(r), void u();
                  r += a;
                }
              }
            } else if ("in parens" === o) {
              if (")" === a) r += a, o = "in descriptor";else {
                if ("" === a) return s.push(r), void u();
                r += a;
              }
            } else if ("after descriptor" === o) if (I(a)) ;else {
              if ("" === a) return void u();
              o = "in descriptor", l -= 1;
            }
            l += 1;
          }
        }

        for (;;) {
          if (i(R), l >= c) return d;
          n = i(D), s = [], "," === n.slice(-1) ? (n = n.replace(O, ""), u()) : f();
        }
      }(e.srcset, e)), e.cands;
    }, d.getEmValue = function () {
      var e;

      if (!a && (e = r.body)) {
        var t = r.createElement("div"),
            i = v.style.cssText,
            n = e.style.cssText;
        t.style.cssText = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)", v.style.cssText = C, e.style.cssText = C, e.appendChild(t), a = t.offsetWidth, e.removeChild(t), a = parseFloat(a, 10), v.style.cssText = i, e.style.cssText = n;
      }

      return a || 16;
    }, d.calcListLength = function (e) {
      if (!(e in E) || _.uT) {
        var t = d.calcLength(function (e) {
          var t,
              i,
              n,
              s,
              r,
              o,
              a,
              c = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,
              l = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

          for (n = (i = function (e) {
            var t,
                i = "",
                n = [],
                s = [],
                r = 0,
                o = 0,
                a = !1;

            function c() {
              i && (n.push(i), i = "");
            }

            function l() {
              n[0] && (s.push(n), n = []);
            }

            for (;;) {
              if ("" === (t = e.charAt(o))) return c(), l(), s;

              if (a) {
                if ("*" === t && "/" === e[o + 1]) {
                  a = !1, o += 2, c();
                  continue;
                }

                o += 1;
              } else {
                if (I(t)) {
                  if (e.charAt(o - 1) && I(e.charAt(o - 1)) || !i) {
                    o += 1;
                    continue;
                  }

                  if (0 === r) {
                    c(), o += 1;
                    continue;
                  }

                  t = " ";
                } else if ("(" === t) r += 1;else if (")" === t) r -= 1;else {
                  if ("," === t) {
                    c(), l(), o += 1;
                    continue;
                  }

                  if ("/" === t && "*" === e.charAt(o + 1)) {
                    a = !0, o += 2;
                    continue;
                  }
                }

                i += t, o += 1;
              }
            }
          }(e)).length, t = 0; t < n; t++) {
            if (r = (s = i[t])[s.length - 1], a = r, c.test(a) && parseFloat(a) >= 0 || l.test(a) || "0" === a || "-0" === a || "+0" === a) {
              if (o = r, s.pop(), 0 === s.length) return o;
              if (s = s.join(" "), d.matchesMedia(s)) return o;
            }
          }

          return "100vw";
        }(e));
        E[e] = t || z.width;
      }

      return E[e];
    }, d.setRes = function (e) {
      var t;
      if (e) for (var i = 0, n = (t = d.parseSet(e)).length; i < n; i++) {
        oe(t[i], e.sizes);
      }
      return t;
    }, d.setRes.res = oe, d.applySetCandidate = function (e, t) {
      if (e.length) {
        var i,
            n,
            s,
            r,
            o,
            a,
            c,
            l,
            u,
            f,
            h,
            p,
            m,
            g,
            v,
            y,
            A = t[d.ns],
            w = d.DPR;
        if (a = A.curSrc || t[$], (c = A.curCan || function (e, t, i) {
          var n;
          return !i && t && (i = (i = e[d.ns].sets) && i[i.length - 1]), (n = le(t, i)) && (t = d.makeUrl(t), e[d.ns].curSrc = t, e[d.ns].curCan = n, n.res || oe(n, n.set.sizes)), n;
        }(t, a, e[0].set)) && c.set === e[0].set && ((u = b && !t.complete && c.res - .1 > w) || (c.cached = !0, c.res >= w && (o = c))), !o) for (e.sort(ce), o = e[(r = e.length) - 1], n = 0; n < r; n++) {
          if ((i = e[n]).res >= w) {
            o = e[s = n - 1] && (u || a !== d.makeUrl(i.url)) && (f = e[s].res, h = i.res, p = w, m = e[s].cached, g = void 0, v = void 0, y = void 0, "saveData" === _.algorithm ? f > 2.7 ? y = p + 1 : (v = (h - p) * (g = Math.pow(f - .6, 1.5)), m && (v += .1 * g), y = f + v) : y = p > 1 ? Math.sqrt(f * h) : f, y > p) ? e[s] : i;
            break;
          }
        }
        o && (l = d.makeUrl(o.url), A.curSrc = l, A.curCan = o, l !== a && d.setSrc(t, o), d.setSize(t));
      }
    }, d.setSrc = function (e, t) {
      var i;
      e.src = t.url, "image/svg+xml" === t.set.type && (i = e.style.width, e.style.width = e.offsetWidth + 1 + "px", e.offsetWidth + 1 && (e.style.width = i));
    }, d.getSet = function (e) {
      var t,
          i,
          n,
          s = !1,
          r = e[d.ns].sets;

      for (t = 0; t < r.length && !s; t++) {
        if ((i = r[t]).srcset && d.matchesMedia(i.media) && (n = d.supportsType(i.type))) {
          "pending" === n && (i = n), s = i;
          break;
        }
      }

      return s;
    }, d.parseSets = function (e, t, i) {
      var n,
          s,
          r,
          o,
          a = t && "PICTURE" === t.nodeName.toUpperCase(),
          l = e[d.ns];
      (void 0 === l.src || i.src) && (l.src = p.call(e, "src"), l.src ? m.call(e, "data-pfsrc", l.src) : g.call(e, "data-pfsrc")), (void 0 === l.srcset || i.srcset || !d.supSrcset || e.srcset) && (n = p.call(e, "srcset"), l.srcset = n, o = !0), l.sets = [], a && (l.pic = !0, function (e, t) {
        var i,
            n,
            s,
            r,
            o = e.getElementsByTagName("source");

        for (i = 0, n = o.length; i < n; i++) {
          (s = o[i])[d.ns] = !0, (r = s.getAttribute("srcset")) && t.push({
            srcset: r,
            media: s.getAttribute("media"),
            type: s.getAttribute("type"),
            sizes: s.getAttribute("sizes")
          });
        }
      }(t, l.sets)), l.srcset ? (s = {
        srcset: l.srcset,
        sizes: p.call(e, "sizes")
      }, l.sets.push(s), (r = (c || l.src) && w.test(l.srcset || "")) || !l.src || le(l.src, s) || s.has1x || (s.srcset += ", " + l.src, s.cands.push({
        url: l.src,
        d: 1,
        set: s
      }))) : l.src && l.sets.push({
        srcset: l.src,
        sizes: null
      }), l.curCan = null, l.curSrc = void 0, l.supported = !(a || s && !d.supSrcset || r && !d.supSizes), o && d.supSrcset && !l.supported && (n ? (m.call(e, "data-pfsrcset", n), e.srcset = "") : g.call(e, "data-pfsrcset")), l.supported && !l.srcset && (!l.src && e.src || e.src !== d.makeUrl(l.src)) && (null === l.src ? e.removeAttribute("src") : e.src = l.src), l.parsed = !0;
    }, d.fillImg = function (e, t) {
      var i,
          n = t.reselect || t.reevaluate;
      e[d.ns] || (e[d.ns] = {}), i = e[d.ns], (n || i.evaled !== l) && (i.parsed && !t.reevaluate || d.parseSets(e, e.parentNode, t), i.supported ? i.evaled = l : function (e) {
        var t,
            i = d.getSet(e),
            n = !1;
        "pending" !== i && (n = l, i && (t = d.setRes(i), d.applySetCandidate(t, e))), e[d.ns].evaled = n;
      }(e));
    }, d.setupRun = function () {
      M && !x && j === s.devicePixelRatio || (x = !1, j = s.devicePixelRatio, T = {}, E = {}, d.DPR = j || 1, z.width = Math.max(s.innerWidth || 0, v.clientWidth), z.height = Math.max(s.innerHeight || 0, v.clientHeight), z.vw = z.width / 100, z.vh = z.height / 100, l = [z.height, z.width, j].join("-"), z.em = d.getEmValue(), z.rem = z.em);
    }, d.supPicture ? (ae = f, d.fillImg = f) : (te = s.attachEvent ? /d$|^c/ : /d$|^c|^i/, _ie = function ie() {
      var e = r.readyState || "";
      ne = setTimeout(_ie, "loading" === e ? 200 : 999), r.body && (d.fillImgs(), (Y = Y || te.test(e)) && clearTimeout(ne));
    }, ne = setTimeout(_ie, r.body ? 9 : 99), se = v.clientHeight, H(s, "resize", (X = function X() {
      x = Math.max(s.innerWidth || 0, v.clientWidth) !== z.width || v.clientHeight !== se, se = v.clientHeight, x && d.fillImgs();
    }, J = 99, _ee = function ee() {
      var e = new Date() - Z;
      e < J ? K = setTimeout(_ee, J - e) : (K = null, X());
    }, function () {
      Z = new Date(), K || (K = setTimeout(_ee, J));
    })), H(r, "readystatechange", _ie)), d.picturefill = ae, d.fillImgs = ae, d.teardownRun = f, ae._ = d, s.picturefillCFG = {
      pf: d,
      push: function push(e) {
        var t = e.shift();
        "function" == typeof d[t] ? d[t].apply(d, e) : (_[t] = e[0], M && d.fillImgs({
          reselect: !0
        }));
      }
    };

    for (; k && k.length;) {
      s.picturefillCFG.push(k.shift());
    }

    s.picturefill = ae, "object" == _typeof(e.exports) ? e.exports = ae : void 0 === (n = function () {
      return ae;
    }.call(t, i, t, e)) || (e.exports = n), d.supPicture || (y["image/webp"] = function (e, t) {
      var i = new s.Image();
      return i.onerror = function () {
        y[e] = !1, ae();
      }, i.onload = function () {
        y[e] = 1 === i.width, ae();
      }, i.src = t, "pending";
    }("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="));
  }(window, document);
}, function (e, t, i) {
  !function (t, i) {
    "use strict";

    var n = function () {
      function e(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, i, n) {
        return i && e(t.prototype, i), n && e(t, n), t;
      };
    }();

    var s,
        r = !1,
        o = void 0 !== t;
    o && t.getComputedStyle ? (s = i.createElement("div"), ["", "-webkit-", "-moz-", "-ms-"].some(function (e) {
      try {
        s.style.position = e + "sticky";
      } catch (e) {}

      return "" != s.style.position;
    }) && (r = !0)) : r = !0;
    var a = !1,
        c = "undefined" != typeof ShadowRoot,
        l = {
      top: null,
      left: null
    },
        d = [];

    function u(e, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (e[i] = t[i]);
      }
    }

    function f(e) {
      return parseFloat(e) || 0;
    }

    function h(e) {
      for (var t = 0; e;) {
        t += e.offsetTop, e = e.offsetParent;
      }

      return t;
    }

    var p = function () {
      function e(t) {
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), !(t instanceof HTMLElement)) throw new Error("First argument must be HTMLElement");
        if (d.some(function (e) {
          return e._node === t;
        })) throw new Error("Stickyfill is already applied to this node");
        this._node = t, this._stickyMode = null, this._active = !1, d.push(this), this.refresh();
      }

      return n(e, [{
        key: "refresh",
        value: function value() {
          if (!r && !this._removed) {
            this._active && this._deactivate();
            var e = this._node,
                n = getComputedStyle(e),
                s = {
              position: n.position,
              top: n.top,
              display: n.display,
              marginTop: n.marginTop,
              marginBottom: n.marginBottom,
              marginLeft: n.marginLeft,
              marginRight: n.marginRight,
              cssFloat: n.cssFloat
            };

            if (!isNaN(parseFloat(s.top)) && "table-cell" != s.display && "none" != s.display) {
              this._active = !0;
              var o = e.style.position;
              "sticky" != n.position && "-webkit-sticky" != n.position || (e.style.position = "static");
              var a = e.parentNode,
                  l = c && a instanceof ShadowRoot ? a.host : a,
                  d = e.getBoundingClientRect(),
                  p = l.getBoundingClientRect(),
                  m = getComputedStyle(l);
              this._parent = {
                node: l,
                styles: {
                  position: l.style.position
                },
                offsetHeight: l.offsetHeight
              }, this._offsetToWindow = {
                left: d.left,
                right: i.documentElement.clientWidth - d.right
              }, this._offsetToParent = {
                top: d.top - p.top - f(m.borderTopWidth),
                left: d.left - p.left - f(m.borderLeftWidth),
                right: -d.right + p.right - f(m.borderRightWidth)
              }, this._styles = {
                position: o,
                top: e.style.top,
                bottom: e.style.bottom,
                left: e.style.left,
                right: e.style.right,
                width: e.style.width,
                marginTop: e.style.marginTop,
                marginLeft: e.style.marginLeft,
                marginRight: e.style.marginRight
              };
              var g = f(s.top);
              this._limits = {
                start: d.top + t.pageYOffset - g,
                end: p.top + t.pageYOffset + l.offsetHeight - f(m.borderBottomWidth) - e.offsetHeight - g - f(s.marginBottom)
              };
              var v = m.position;
              "absolute" != v && "relative" != v && (l.style.position = "relative"), this._recalcPosition();
              var y = this._clone = {};
              y.node = i.createElement("div"), u(y.node.style, {
                width: d.right - d.left + "px",
                height: d.bottom - d.top + "px",
                marginTop: s.marginTop,
                marginBottom: s.marginBottom,
                marginLeft: s.marginLeft,
                marginRight: s.marginRight,
                cssFloat: s.cssFloat,
                padding: 0,
                border: 0,
                borderSpacing: 0,
                fontSize: "1em",
                position: "static"
              }), a.insertBefore(y.node, e), y.docOffsetTop = h(y.node);
            }
          }
        }
      }, {
        key: "_recalcPosition",
        value: function value() {
          if (this._active && !this._removed) {
            var e = l.top <= this._limits.start ? "start" : l.top >= this._limits.end ? "end" : "middle";

            if (this._stickyMode != e) {
              switch (e) {
                case "start":
                  u(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: this._offsetToParent.top + "px",
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;

                case "middle":
                  u(this._node.style, {
                    position: "fixed",
                    left: this._offsetToWindow.left + "px",
                    right: this._offsetToWindow.right + "px",
                    top: this._styles.top,
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;

                case "end":
                  u(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: "auto",
                    bottom: 0,
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0
                  });
              }

              this._stickyMode = e;
            }
          }
        }
      }, {
        key: "_fastCheck",
        value: function value() {
          this._active && !this._removed && (Math.abs(h(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) && this.refresh();
        }
      }, {
        key: "_deactivate",
        value: function value() {
          var e = this;
          this._active && !this._removed && (this._clone.node.parentNode.removeChild(this._clone.node), delete this._clone, u(this._node.style, this._styles), delete this._styles, d.some(function (t) {
            return t !== e && t._parent && t._parent.node === e._parent.node;
          }) || u(this._parent.node.style, this._parent.styles), delete this._parent, this._stickyMode = null, this._active = !1, delete this._offsetToWindow, delete this._offsetToParent, delete this._limits);
        }
      }, {
        key: "remove",
        value: function value() {
          var e = this;
          this._deactivate(), d.some(function (t, i) {
            if (t._node === e._node) return d.splice(i, 1), !0;
          }), this._removed = !0;
        }
      }]), e;
    }(),
        m = {
      stickies: d,
      Sticky: p,
      forceSticky: function forceSticky() {
        r = !1, g(), this.refreshAll();
      },
      addOne: function addOne(e) {
        if (!(e instanceof HTMLElement)) {
          if (!e.length || !e[0]) return;
          e = e[0];
        }

        for (var t = 0; t < d.length; t++) {
          if (d[t]._node === e) return d[t];
        }

        return new p(e);
      },
      add: function add(e) {
        if (e instanceof HTMLElement && (e = [e]), e.length) {
          for (var t = [], i = function i(_i) {
            var n = e[_i];
            return n instanceof HTMLElement ? d.some(function (e) {
              if (e._node === n) return t.push(e), !0;
            }) ? "continue" : void t.push(new p(n)) : (t.push(void 0), "continue");
          }, n = 0; n < e.length; n++) {
            i(n);
          }

          return t;
        }
      },
      refreshAll: function refreshAll() {
        d.forEach(function (e) {
          return e.refresh();
        });
      },
      removeOne: function removeOne(e) {
        if (!(e instanceof HTMLElement)) {
          if (!e.length || !e[0]) return;
          e = e[0];
        }

        d.some(function (t) {
          if (t._node === e) return t.remove(), !0;
        });
      },
      remove: function remove(e) {
        if (e instanceof HTMLElement && (e = [e]), e.length) for (var t = function t(_t) {
          var i = e[_t];
          d.some(function (e) {
            if (e._node === i) return e.remove(), !0;
          });
        }, i = 0; i < e.length; i++) {
          t(i);
        }
      },
      removeAll: function removeAll() {
        for (; d.length;) {
          d[0].remove();
        }
      }
    };

    function g() {
      if (!a) {
        a = !0, r(), t.addEventListener("scroll", r), t.addEventListener("resize", m.refreshAll), t.addEventListener("orientationchange", m.refreshAll);
        var e = void 0,
            n = void 0,
            s = void 0;
        "hidden" in i ? (n = "hidden", s = "visibilitychange") : "webkitHidden" in i && (n = "webkitHidden", s = "webkitvisibilitychange"), s ? (i[n] || o(), i.addEventListener(s, function () {
          i[n] ? clearInterval(e) : o();
        })) : o();
      }

      function r() {
        t.pageXOffset != l.left ? (l.top = t.pageYOffset, l.left = t.pageXOffset, m.refreshAll()) : t.pageYOffset != l.top && (l.top = t.pageYOffset, l.left = t.pageXOffset, d.forEach(function (e) {
          return e._recalcPosition();
        }));
      }

      function o() {
        e = setInterval(function () {
          d.forEach(function (e) {
            return e._fastCheck();
          });
        }, 500);
      }
    }

    r || g(), e.exports ? e.exports = m : o && (t.Stickyfill = m);
  }(window, document);
}, function (e, t, i) {
  "use strict";

  i.r(t);

  var n =
  /*#__PURE__*/
  function () {
    function n() {
      _classCallCheck(this, n);
    }

    _createClass(n, [{
      key: "init",
      value: function init() {
        var e = this;
        $("body").on("click", ".js--popup-switch", function (t) {
          t.preventDefault();
          var i = $(this).data("action");
          i || console.warning("Action is not set on clicked element"), i.forEach(function (t) {
            var i = t.class;
            void 0 !== t.open && e.open(t.open, i), void 0 !== t.close && e.close(t.close, i), void 0 !== t.toggle && e.toggle(t.toggle, i);
          });
        }), $("body").on("click", ".js--mega-nav", function (t) {
          t.preventDefault(), e.close(".mega-nav:not(.js--mega-nav-element)", "open"), e.toggle(".js--mega-nav-element", "open"), e.close("body", "search-open minicart-open"), e.close(".js--header", "open"), $(".js--mega-nav-element").hasClass("open") ? $(".js--header").addClass("header--force-background") : $(".js--header").removeClass("header--force-background");
        });
      }
    }, {
      key: "open",
      value: function open(e, t) {
        $(e).addClass(t);
      }
    }, {
      key: "close",
      value: function close(e, t) {
        $(e).removeClass(t);
      }
    }, {
      key: "toggle",
      value: function toggle(e, t) {
        $(e).toggleClass(t);
      }
    }]);

    return n;
  }(),
      s = i(1);

  var r =
  /*#__PURE__*/
  function () {
    function r() {
      _classCallCheck(this, r);

      this.hamburgerSelector = ".js--hamburger", this.headerSelector = ".js--header", this.megaMenuSelector = ".js--products-nav a", this.scrollOffset = 19, this.isScrolled = !1, this.trigger(), this.stickyPolyfill(), this.search(), this.minicart(), this.formSubmit(), this.fetchMegaMenu(), $(".header--transparent").length && this.scroll();
    }

    _createClass(r, [{
      key: "trigger",
      value: function trigger() {
        var _this = this;

        $(this.hamburgerSelector).on("click", function (e) {
          e.preventDefault(), $(_this.headerSelector).toggleClass("open");
        });
      }
    }, {
      key: "scroll",
      value: function scroll() {
        var e = this;
        $(window).on("scroll", function () {
          $(window).scrollTop() > e.scrollOffset ? e.isScrolled || ($(".header--transparent").removeClass("hero--transparency"), e.isScrolled = !0) : e.isScrolled && ($(".header--transparent").addClass("hero--transparency"), e.isScrolled = !1);
        }), $(window).trigger("scroll");
      }
    }, {
      key: "stickyPolyfill",
      value: function stickyPolyfill() {
        s.add($(this.headerSelector));
      }
    }, {
      key: "formSubmit",
      value: function formSubmit() {
        $(".js--form-submit").on("click", function (e) {
          e.preventDefault(), $(this).closest("form").submit();
        });
      }
    }, {
      key: "search",
      value: function search() {
        $(".js--search-trigger").on("click", function (e) {
          e.preventDefault(), $("body").toggleClass("search-open"), $("body").hasClass("search-open") && ($("body").removeClass("minicart-open"), window.searchSetTimeout = setTimeout(function () {
            $(".js--big-search-input").focus();
          }, 250));
        });
      }
    }, {
      key: "minicart",
      value: function minicart() {
        $(".js--toggle-minicart").on("click", function (e) {
          e.preventDefault(), $("body").hasClass("minicart-open") || $.getJSON("/cart.js", function (e) {
            // $('.td__atc__sticky').toggleClass('show_td__atc__sticky');
            $(".header .minicart__table").html("");
            var t = "";
            0 == e.items.length ? t += '<p class="text-center">Your cart is currently empty.</p>' : (t += '<div class="minicart__header">\n                <div class="minicart__cell"><h6>Product</h6></div>\n                <div class="minicart__cell"><h6>Size</h6></div>\n                <div class="minicart__cell"><h6><span class="tablet">Quantity</span><span class="mobile">QTY</span></h6></div>\n                <div class="minicart__cell"><h6>Price</h6></div>\n              </div>', 
            $.each(e.items, function (e, i) {
              i.hasOwnProperty('selling_plan_allocation') ? t += "<div class=\"minicart__product\">\n                <div class=\"minicart__cell\"><div class=\"minicart__image\"><img src=\"".concat(i.image.replace(".jpg", "_95x95.jpg").replace(".jpeg", "_95x95.jpeg").replace(".gif", "_95x95.gif").replace(".png", "_95x95.png"), "\"></div></div>\n                <div class=\"minicart__cell\"><div><span class=\"list-view-item__title\">").concat(i.product_title, "</span><br><span class=\"product-details__item product-details__item--property\">" +  i.selling_plan_allocation.selling_plan.name + "</span></div></div>\n                <div class=\"minicart__cell\"><span class=\"product-details__item product-details__item--variant-option\">").concat(i.variant_title ? i.variant_title : "-", "</span></div>\n                <div class=\"minicart__cell cart__qty cart__qty--cart\"><label for=\"updates_").concat(i.key, "\" class=\"cart__qty-label\" data-quantity-label-mobile></label></div>\n                <div class=\"minicart__cell\"><div class=\"minicart__cell-container\"><h5>$").concat((i.final_line_price / 100).toFixed(2), "</h5></div></div>\n              </div>") : t += "<div class=\"minicart__product\">\n                <div class=\"minicart__cell\"><div class=\"minicart__image\"><img src=\"".concat(i.image.replace(".jpg", "_95x95.jpg").replace(".jpeg", "_95x95.jpeg").replace(".gif", "_95x95.gif").replace(".png", "_95x95.png"), "\"></div></div>\n                <div class=\"minicart__cell\"><div><span class=\"list-view-item__title\">").concat(i.product_title, "</span><br></div></div>\n                <div class=\"minicart__cell\"><span class=\"product-details__item product-details__item--variant-option\">").concat(i.variant_title ? i.variant_title : "-", "</span></div>\n                <div class=\"minicart__cell cart__qty cart__qty--cart\"><label for=\"updates_").concat(i.key, "\" class=\"cart__qty-label\" data-quantity-label-mobile></label><div class=\"number-field-buttons selector-wrapper selector-wrapper--cart\"><input id='updates_").concat(i.key, "' class='cart__qty-input' type='number' disabled='true' value='").concat(i.quantity, "' min='0' pattern='[0-9]*' data-quantity-input data-quantity-item='").concat(e+1, "' data-quantity-input-mobile><a href='/cart/change?line=").concat(e+1, "&amp;quantity=").concat(i.quantity-1, "' class='number-field-button js--input-number-minus'>-</a><a href='/cart/change?line=").concat(e+1, "&amp;quantity=").concat(i.quantity+1, "' class='number-field-button js--input-number-plus'>+</a></div></div>\n                <div class=\"minicart__cell\"><div class=\"minicart__cell-container\"><h5>$").concat((i.final_line_price / 100).toFixed(2), "</h5></div></div>\n              <div class=\"minicart__cell\"><p class='cart__remove'><a href='/cart/change?line=").concat(e+1,"&amp;quantity=0' class='text-link text-link--accent' data-cart-remove>Remove</a></p></div>\n                </div>");
            }), t += "<div class=\"minicart__foot\">\n                <div class=\"minicart__cell\"></div>\n                <div class=\"minicart__cell\"><h6>Subtotal</h6></div>\n                <div class=\"minicart__cell\"></div>\n                <div class=\"minicart__cell\"><h5>$".concat((e.total_price / 100).toFixed(2)).concat(e.total_discount ? "<br><sup>(-$" + (e.total_discount / 100).toFixed(2) + ")</sup>" : "", "</h5></div>\n              </div>")), $(".header .minicart__table").append(t);
          });
          var t = new n();
          const pagePath = window.location.pathname;
          if(pagePath === '/cart') {
            t.close("body", "minicart-open");
          } else {
            t.toggle("body", "minicart-open");
          }
          t.close(".mega-nav, .header", "open"), t.close("body", "search-open"), t.close(".td__atc__sticky", "show_td__atc__sticky");
        });
      }
    }, {
      key: "fetchMegaMenu",
      value: function fetchMegaMenu() {
        $.get("https://organicindiausa.com/", function (e) {
          $(e).find(".mega-nav").each(function (e, t) {
            $(".js--header").append(t);
          });
        }).always(function () {});
      }
    }]);

    return r;
  }();

  var o =
  /*#__PURE__*/
  function () {
    function o() {
      _classCallCheck(this, o);

      this.shareButton(), this.copyToClipboard(), this.inputFieldButtons();
    }

    _createClass(o, [{
      key: "shareButton",
      value: function shareButton() {
        $(".js--share-link").on("click", function (e) {
          if ($(window).width() > 768) {
            e.preventDefault();
            var t = $(this).attr("href"),
                i = $(window).height() / 2 - 200,
                n = $(window).width() / 2 - 275;
            window.open(t, "sharer", "top=" + i + ",left=" + n + ",toolbar=0,status=0,width=550,height=400");
          }
        }), $(".js--product-share-trigger").on("click", function (e) {
          e.preventDefault(), $(this).toggleClass("active");
        });
      }
    }, {
      key: "copyToClipboard",
      value: function copyToClipboard() {
        $(".js--copy-text").on("click", function (e) {
          e.preventDefault();
          var t = $(this).data("link"),
              i = document.createElement("textarea");
          i.value = t, document.body.appendChild(i), i.select(), document.execCommand("Copy"), i.remove(), console.log("copied");
        });
      }
    }, {
      key: "inputFieldButtons",
      value: function inputFieldButtons() {
        $(".js--input-number-minus").on("click", function (e) {
          e.preventDefault();
          var t = $(this).siblings("input");
          parseInt(t.val()) > 0 && t.val(parseInt(t.val()) - 1);
        }), $(".js--input-number-plus").on("click", function (e) {
          e.preventDefault();
          var t = $(this).siblings("input");
          t.val(parseInt(t.val()) + 1);
        });
      }
    }]);

    return o;
  }();

  var a = function a() {
    _classCallCheck(this, a);

    this.selector = ".js--testimonials", document.querySelector(this.selector) && $(this.selector).slick({
      dots: !0,
      autoplay: !1,
      pauseOnHover: !1,
      pauseOnFocus: !1,
      speed: 700,
      autoplaySpeed: 6e3,
      infinite: !0,
      fade: !1
    });
  };

  var c =
  /*#__PURE__*/
  function () {
    function c() {
      _classCallCheck(this, c);

      var e = this;
      this.filters(), this.ajax(), $(window).on("resize", function () {
        e.resizeFilterGroups(), e.resizeFilterSidebar();
      }), this.resizeFilterSidebar(), this.resizeFilterGroups();
    }

    _createClass(c, [{
      key: "filters",
      value: function filters() {
        var e = this;
        $("body").on("click", ".js--toggle-filter-category", function (t) {
          t.preventDefault(), $(this).toggleClass("active"), e.resizeFilterGroups();
        }), $("body").on("click", ".js--open-filters-mobile", function (t) {
          t.preventDefault(), $(this).toggleClass("active"), $(".collection-page__sidebar").toggleClass("active"), e.resizeFilterSidebar();
        });
      }
    }, {
      key: "resizeFilterGroups",
      value: function resizeFilterGroups() {
        $(".js--toggle-filter-category").each(function (e, t) {
          var i = $(t).next();
          $(t).hasClass("active") ? (i.height(i.find(".filters__subgroup").outerHeight() + 20), setTimeout(function () {
            $(t).css("height", "");
          }, 200)) : i.height(0);
        });
      }
    }, {
      key: "resizeFilterSidebar",
      value: function resizeFilterSidebar() {
        $(".collection-page__sidebar").each(function (e, t) {
          $(t).hasClass("active") ? ($(t).height($(t).find(".filters").outerHeight(!0)), setTimeout(function () {
            $(t).css("height", "auto");
          }, 200)) : $(t).height(0);
        });
      }
    }, {
      key: "ajax",
      value: function ajax() {
        var e = this;
        $("body").on("click", ".js--filter", function (t) {
          t.preventDefault(), $(".js--store-page").addClass("loading");
          var i = $(this).attr("href");
          $.get(i, function (t) {
            var n = $($(t).find(".js--store-page")[0]).html();
            $(".js--store-page").html(n), e.resizeFilterSidebar(), e.resizeFilterGroups(), history.replaceState(null, null, i);
            window.dispatchEvent(new CustomEvent('td:ajax:done'));
          }).always(function () {
            $(".js--store-page").removeClass("loading");
          });
        });
      }
    }]);

    return c;
  }();

  var l = function l() {
    _classCallCheck(this, l);

    $("p").each(function () {
      $(this).html($(this).html().replace(/organic india/gi, '<span class="brand-name">Organic India</span>'));
    });
  };

//   var d = function d() {
//     _classCallCheck(this, d);

//     var e = [];
//     $(".js--pr-review-snippet").each(function (t, i) {
//       e.push({
//         api_key: "d6ce87ca-a084-4505-898f-2ac38037523d",
//         locale: "en_US",
//         merchant_group_id: "79243",
//         merchant_id: "406676",
//         page_id: $(i).data("product-id"),
//         review_wrapper_url: "https://organicindiausa.myshopify.com/pages/write-a-review/?pr_page_id=" + $(i).data("id"),
//         components: {
//           ReviewSnippet: $(i).attr("id")
//         }
//       });
//     }), $(".js--pr-review-display").each(function (t, i) {
//       e.push(window[$(i).data("var")]);
//     }), console.log(e), e.length > 0 && POWERREVIEWS.display.render(e);
//   };

  var u = function u() {
    _classCallCheck(this, u);

    $(".js--tabs").each(function (e) {
      var t = [],
          i = $(this);
      i.find(".js--block-tab-link").each(function (e, n) {
        t[e] = $(n).data("selector"), $(this).on("click", function (e) {
          e.preventDefault();
          var n = i.find(".js--block-tab-link").index($(this));
          console.log(n), $(this).hasClass("active") || (i.find(".js--block-tab-link.active").removeClass("active"), $(this).addClass("active"), $.each(t, function (e, t) {
            e == n ? $(t).removeClass("tab-hidden") : $(t).addClass("tab-hidden");
          }));
        });
      }), $.each(t, function (e, t) {
        $(t).addClass(0 == e ? "tabbed-element" : "tabbed-element tab-hidden");
      });
    });
  };

  var f = function f() {
    _classCallCheck(this, f);

    $(".js--search-pages").each(function () {
      var e = $(this),
          t = $(this).data("search");
      $.get("https://organicindiausa.com/", {
        s: t
      }, function (t) {
        var i = $($(t).find(".js--search-pages")[0]).html();
        e.html(i);
      });
    });
  };

  var h =
  /*#__PURE__*/
  function () {
    function h() {
      _classCallCheck(this, h);

      this.playVideo(), this.closeVideo(), this.closeEverything();
    }

    _createClass(h, [{
      key: "playVideo",
      value: function playVideo() {
        $(document).on("click", ".js--destini", function (e) {
          e.preventDefault();
          var t = $(this).attr("data-destini-container"),
              i = $(this).attr("data-destini-association"),
              n = $(this).attr("data-destini-apo");
          destini.init(t), destini.loadWidget(i, n), setTimeout(function () {
            $("#destinidiv iframe").attr("scrolling", "yes");
          }, 500), $(".js--destini-modal").removeClass("video-modal--destini"), $("body").addClass("video-modal-open");
        });
      }
    }, {
      key: "closeVideo",
      value: function closeVideo() {
        $(document).on("click", ".js--video-modal-close", function (e) {
          e.preventDefault(), $(".js--destini-modal").addClass("video-modal--destini"), $("body").removeClass("video-modal-open");
        });
      }
    }, {
      key: "closeEverything",
      value: function closeEverything() {
        document.onkeydown = function (e) {
          ("key" in (e = e || window.event) ? "Escape" === e.key || "Esc" === e.key : 27 === e.keyCode) && ($(".js--destini-modal").addClass("video-modal--destini"), $("body").removeClass("video-modal-open"));
        };
      }
    }]);

    return h;
  }();

  i(0), window.addEventListener("load", function () {
    new r(), new o(), new a(), new c(), new l(), new u(), new f();
    new n().init();
    new h();
  });
}]);

